import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ad63c564a22f9edd061d7e4bbb72110b2b from "./generated-59488b02-88c1-4bde-8558-23eeff1ef3f6.json";

import a63301cc3d4e4638b804b08f2ec720828b from "./generated-c0a53e57-1f4f-4aa4-8a7c-6b4a469ee4bb.json";

import a68b3e238c6a6c5ca755414a0a8198d9bb from "./generated-797e1afb-e7db-44af-8d17-80d834d5b86b.json";

import ac052488bdf14651a5e591a5290deb72eb from "./generated-79a25c03-c788-4313-a892-db9441d5e07d.json";

import a5faf4d60e1b82cb8175171dfb5d7790ab from "./generated-37c3b657-0c4e-41bd-9c6f-6e833a67a602.json";

import a640b53975cdc2ea9e736afac857514acb from "./generated-8f4e2019-e0a7-4ff4-b973-5931ec7bb8a3.json";

import ae88ea284766cf39a08b381a01903a700b from "./generated-7a32d017-d341-44b9-9011-3336dbeff8bd.json";

import a2e50ea679e1050977b7ee36aaba665cbb from "./generated-95123ea2-c97e-41bb-b50f-a0f16ba37a37.json";

import a3fbafcbfd658a74274fea3b5a44ad621b from "./generated-48b2c1f3-200d-42a2-99e2-31f641b76ac6.json";

import a59c259b109c71e30a6315d9ac4bab5bcb from "./generated-fce23633-7948-4efd-bbd9-9ceab5b7e687.json";

import a5bf6216220d01fbf20c7ebce83d693e6b from "./generated-d8624311-eb04-4c22-8ac0-2adf2b571d02.json";

import afc7cc6f90c2d752516f1a12b5942c7beb from "./generated-5b9b1c95-f5fe-4cef-8954-834af3d8d9a5.json";

import adff98c5904662fa0f3db98dc93f48788b from "./generated-451b86b5-443d-43aa-bdce-3a4957e73df2.json";

import a458f6fdf3a3e9ef1c02c3dd21b86fd31b from "./generated-23d5fbd3-6ddc-4dc4-bb7b-23ecd3bfdeff.json";

import abde6896d454939b0d186be37392b7772b from "./generated-8093eff9-ae0a-44a2-9368-36cb00d37425.json";

import a36db1f826b7a8c5aedc08db3d3be36d0b from "./generated-1b4804da-6755-41e6-97a3-6ea6a407f164.json";

import ad797a97b90ac5fde5a301f3de686d84ab from "./generated-2d0a696d-4996-44d6-859c-b251ccdb5693.json";

import aed4b16616404a163fa42f3aaaf52af2eb from "./generated-d60406f5-4f6f-4cf9-9942-cd773fbecebb.json";

import a19db3b518b5c0b1345e90e18bc56c8a2b from "./generated-c66cfd50-f238-4f54-b45a-95362520ea30.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ad63c564a22f9edd061d7e4bbb72110b2b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a63301cc3d4e4638b804b08f2ec720828b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a68b3e238c6a6c5ca755414a0a8198d9bb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ac052488bdf14651a5e591a5290deb72eb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a5faf4d60e1b82cb8175171dfb5d7790ab);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a640b53975cdc2ea9e736afac857514acb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ae88ea284766cf39a08b381a01903a700b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a2e50ea679e1050977b7ee36aaba665cbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a3fbafcbfd658a74274fea3b5a44ad621b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a59c259b109c71e30a6315d9ac4bab5bcb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a5bf6216220d01fbf20c7ebce83d693e6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(afc7cc6f90c2d752516f1a12b5942c7beb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(adff98c5904662fa0f3db98dc93f48788b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a458f6fdf3a3e9ef1c02c3dd21b86fd31b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(abde6896d454939b0d186be37392b7772b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a36db1f826b7a8c5aedc08db3d3be36d0b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ad797a97b90ac5fde5a301f3de686d84ab);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aed4b16616404a163fa42f3aaaf52af2eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a19db3b518b5c0b1345e90e18bc56c8a2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ad797a97b90ac5fde5a301f3de686d84ab);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */